<core-svg [svg]="svg" [style.max-width]="svgMaxWidth + svgMaxWidthUnit"></core-svg>
<h5 *ngIf="title">{{ title }}</h5>
<p>
  <ng-content></ng-content>
</p>
<button *ngIf="ctaLabel" coreButton variant="primary" (click)="ctaClick.emit()">
  {{ ctaLabel }}
</button>
